import React from "react";
import { Button } from "reactstrap";
import Cross from "../../../assets/images/verboden/cross.png";
import PlayerInfo from "./playerInfo";
import { connect } from "react-redux";
import { removeUser } from "../../../components/shared/utils";
import { compose } from "redux";
import { withSocket } from "../../../socket/context";
import cx from "classnames";
import BlueCross from "../../../assets/images/verboden/blue-cross.png";
import PurpleCross from "../../../assets/images/verboden/purple-cross.png";

import { motion } from "framer-motion";
import {
  slideHorizontalLeftVariants,
  slideHorizontalRightVariants,
  slideStaticVariants
} from "../../../components/shared/utils/animations";

class VBPlayers extends React.Component {
  delPlayer = async (data) => {
    let roomObj = this.props.gameReducer.roomObj;
    await removeUser(roomObj, data);
  };

  render() {
    const {
      players,
      roomUsers,
      teamData,
      roomData,
      socket,
      teamName,
      teamScore,
      activeTeam,
      gameStatus,
      type,
      current_round
    } = this.props;
    let quaterBack = "";
    if (teamData && teamData.quarterback) {
      quaterBack = roomUsers.find(
        (user) => user.player_id === teamData.quarterback
      );
    }
    let gameObj = this.props.paramsReducer.gameObj;
    let qbText =
      gameObj &&
      gameObj.screens &&
      gameObj.screens.vb &&
      (gameObj.screens.vb.qb_label_a || gameObj.screens.vb.qb_label_b);
    const { pathname } = window.location;
    const fgdhfdsf = () => {
      if (gameStatus === "PreGuess" && current_round === 1) {
        if (type === "teamA") {
          return slideHorizontalLeftVariants;
        } else {
          return slideHorizontalRightVariants;
        }
      } else return slideStaticVariants;
    };
    return (
      <motion.div
        variants={fgdhfdsf()}
        initial="hidden"
        animate="visible"
        exit="exit"
        className={`team-players-wrapper ${type} ${
          gameStatus === "Over" ? "" : activeTeam ? "active-team" : ""
        }`}
      >
        <div className="team-players">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="mb-0 team-title">
              {teamName}
              {/* {gameStatus === "Over" ? (
                ""
              ) : activeTeam ? (
                <span className="text-lightGreen"> guessing</span>
              ) : null} */}
            </h2>
            <div className="count-wrap">
              <div className="count">{teamData ? teamData.score : 0}</div>
            </div>
          </div>
          <div
            className={cx("team-player-list-wrap", {
              withPlayerInfo:
                pathname !== "/verboden/result" &&
                pathname !== "/verboden/final" &&
                quaterBack &&
                quaterBack !== ""
            })}
          >
            {players &&
              players.length > 0 &&
              players.map((data, index) => {
                const playerOfTeam = roomUsers.find(
                  (user) => user.player_id === data
                );
                if (playerOfTeam) {
                  return (
                    <div key={index} className="team-player-list">
                      <div className="d-flex align-items-center">
                        <img
                          src={playerOfTeam.profile_image}
                          className="profile-img"
                        />
                        <p className="text mb-0">{playerOfTeam.display_name}</p>
                      </div>
                      <Button onClick={() => this.delPlayer(playerOfTeam)}>
                        <i className="fas fa-times" />
                      </Button>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            {(pathname === "/verboden/result" ||
              pathname === "/verboden/final") &&
              !!quaterBack && (
                <div className="team-player-list">
                  <div className="d-flex align-items-center">
                    <img
                      src={quaterBack.profile_image}
                      className="profile-img"
                    />
                    <p className="text mb-0">{quaterBack.display_name}</p>
                  </div>
                  <Button
                    color="themePink"
                    onClick={() => this.delPlayer(quaterBack)}
                  >
                    <img src={Cross} />
                  </Button>
                </div>
              )}
          </div>
          {pathname !== "/verboden/result" &&
            pathname !== "/verboden/final" &&
            quaterBack &&
            quaterBack !== "" && (
              <PlayerInfo
                roomData={roomData}
                socket={socket}
                quaterBack={quaterBack}
                qbText={qbText}
              />
            )}
        </div>
      </motion.div>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer
});

export default compose(withSocket, connect(mapStateToProps, null))(VBPlayers);
